/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  PoolTransactionHolderBonus,
  PoolTransactionHolderBonusFromJSON,
  PoolTransactionHolderBonusFromJSONTyped,
  PoolTransactionHolderBonusToJSON,
} from './PoolTransactionHolderBonus'
import {
  PoolTransactionPool,
  PoolTransactionPoolFromJSON,
  PoolTransactionPoolFromJSONTyped,
  PoolTransactionPoolToJSON,
} from './PoolTransactionPool'
import {
  PoolTransactionTokenAmounts,
  PoolTransactionTokenAmountsFromJSON,
  PoolTransactionTokenAmountsFromJSONTyped,
  PoolTransactionTokenAmountsToJSON,
} from './PoolTransactionTokenAmounts'
import { TxType, TxTypeFromJSON, TxTypeFromJSONTyped, TxTypeToJSON } from './TxType'

/**
 *
 * @export
 * @interface PoolTransaction
 */
export interface PoolTransaction {
  /**
   *
   * @type {number}
   * @memberof PoolTransaction
   */
  timestamp?: number
  /**
   *
   * @type {string}
   * @memberof PoolTransaction
   */
  txHash?: string
  /**
   *
   * @type {number}
   * @memberof PoolTransaction
   */
  txFee?: number
  /**
   *
   * @type {PoolTransactionPool}
   * @memberof PoolTransaction
   */
  pool?: PoolTransactionPool
  /**
   *
   * @type {PoolTransactionTokenAmounts}
   * @memberof PoolTransaction
   */
  tokenAmounts?: PoolTransactionTokenAmounts
  /**
   *
   * @type {PoolTransactionHolderBonus}
   * @memberof PoolTransaction
   */
  holderBonus?: PoolTransactionHolderBonus
  /**
   *
   * @type {TxType}
   * @memberof PoolTransaction
   */
  txType?: TxType
}

export function PoolTransactionFromJSON(json: any): PoolTransaction {
  return PoolTransactionFromJSONTyped(json, false)
}

export function PoolTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoolTransaction {
  if (json === undefined || json === null) {
    return json
  }
  return {
    timestamp: !exists(json, 'timestamp') ? undefined : json['timestamp'],
    txHash: !exists(json, 'txHash') ? undefined : json['txHash'],
    txFee: !exists(json, 'txFee') ? undefined : json['txFee'],
    pool: !exists(json, 'pool') ? undefined : PoolTransactionPoolFromJSON(json['pool']),
    tokenAmounts: !exists(json, 'tokenAmounts') ? undefined : PoolTransactionTokenAmountsFromJSON(json['tokenAmounts']),
    holderBonus: !exists(json, 'holderBonus') ? undefined : PoolTransactionHolderBonusFromJSON(json['holderBonus']),
    txType: !exists(json, 'txType') ? undefined : TxTypeFromJSON(json['txType']),
  }
}

export function PoolTransactionToJSON(value?: PoolTransaction | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    timestamp: value.timestamp,
    txHash: value.txHash,
    txFee: value.txFee,
    pool: PoolTransactionPoolToJSON(value.pool),
    tokenAmounts: PoolTransactionTokenAmountsToJSON(value.tokenAmounts),
    holderBonus: PoolTransactionHolderBonusToJSON(value.holderBonus),
    txType: TxTypeToJSON(value.txType),
  }
}
